import { render, staticRenderFns } from "./Params_astrometry.vue?vue&type=template&id=020c8d95&"
import script from "./Params_astrometry.vue?vue&type=script&lang=js&"
export * from "./Params_astrometry.vue?vue&type=script&lang=js&"
import style0 from "./Params_astrometry.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('020c8d95')) {
      api.createRecord('020c8d95', component.options)
    } else {
      api.reload('020c8d95', component.options)
    }
    module.hot.accept("./Params_astrometry.vue?vue&type=template&id=020c8d95&", function () {
      api.rerender('020c8d95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/星盤組件/Params_astrometry.vue"
export default component.exports